// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import sidebar from './components/Sidebar'

import bannerTop from './components/BannerTop'
import top from './components/Top'
import './assets/css/main.css'

Vue.config.productionTip = false
Vue.use(ElementUI)

Vue.component('side_bar', sidebar)
Vue.component('banner-top', bannerTop)
Vue.component('top', top)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js